import React, { useEffect } from "react";
const ShopifyRedirectPage: React.FC = () => {
  useEffect(() => {
    // Extract query parameters from the URL
    const queryParams = new URLSearchParams(window.location.search);
    console.log("queryParams", queryParams)
    const shop = queryParams.get("shop");
    const code = queryParams.get("code");
    const hmac = queryParams.get("hmac");
    const timestamp = queryParams.get("timestamp");
    const state = queryParams.get("state");
    // const { shop, code, hmac, timestamp, state }: any = queryParams;
    // Send the extracted data to the original window
    if (window.opener) {
      window.opener.postMessage({ shop, code, hmac, timestamp, state }, "*");
    }
    // Optionally, close the current window after sending the message
    window.close();
  }, []);
  return (
    <div>
      <h2>Processing...</h2>
      <p>You will be redirected shortly.</p>
    </div>
  );
};
export default ShopifyRedirectPage;